import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './translations/en.json';
import hu from './translations/hu.json';
import ro from './translations/ro.json';
import ger from './translations/german.json';
import empty from './translations/empty.json';
i18n.use(initReactI18next).init({
	lng: 'en', // 'en' | 'hu'
	fallbackLng: false, // Disable fallback to show keys when translation is missing
	resources: {
		en: {
			translation: en,
		},
		ro: {
			translation: ro,
		},

		hu: {
			translation: hu,
		},
		ger: {
			translation: ger,
		},
		empty: {
			translation: empty,
		},
	},
	debug: true,
	react: {
		wait: true,
		useSuspense: true,
	},
	interpolation: {
		escapeValue: false,
	},
	returnEmptyString: false,
	returnNull: false,
});

export default i18n;
